import { useState } from 'react'
import { Grid, Select, MenuItem, FormControl, InputLabel, TextField, Tooltip } from '@mui/material'
import { useSelector } from 'react-redux'

import { Settings } from '../../models/settings'
import { useForm } from '../../hooks/useForm2'
import { Buttons } from '../reusableUI/Buttons'
import { Selects } from '../reusableUI/Selects'
import { DialogFormaPago } from './formas_pago/DialogFormaPago'

export const AjustesGastos = () => {

    const { listaFormasPagos, listaTiposDocumentos, detail } = useSelector(state => state.general)

    const [openDialogFormaPago, setOpenDialogFormaPago] = useState(false)

    const { form, onInputChange } = useForm({
        id: detail.id,
        id_forma_pago: detail.id_forma_pago,
        id_tipo_documento: detail.id_tipo_documento,
        observaciones_compras: detail.observaciones_compras,
        nombre_tipo_compra: detail.nombre_tipo_compra
    })

    const handleSubmit = async (e) => {
        e.preventDefault()
        console.log('form', form)
        await Settings.updateInfoGasto(form)
    }

    return (
        <div className="container p-container-info-personal">

            <div className="row p-contet-title-info-personal">
                <div className="col-12">
                    <h3 className='text-start p-title-info-personal'>Ajustes predeterminados</h3>
                </div>
                <div className="col-12 p-text-info-personal">
                    <h6>Algunos datos se mostrarán por defecto al realizar una compra</h6>
                </div>
            </div>

            <form onSubmit={handleSubmit} className='mt-5'>

                <Grid container spacing='20' columnSpacing='16' rowSpacing='10' alignItems='center' direction='row'>

                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                            <Select
                                label="Tipo de documento"
                                id="id_tipo_documento"
                                name="id_tipo_documento"
                                value={form.id_tipo_documento}
                                onChange={onInputChange}
                                style={{ textTransform: 'uppercase' }}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaTiposDocumentos.map(item => (
                                    <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* <Grid item xs={12} sm={6}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">Forma de pago</InputLabel>
                            <Select
                                label="Forma de pago"
                                id="id_forma_pago"
                                name="id_forma_pago"
                                value={form.id_forma_pago}
                                onChange={onInputChange}
                                style={{ textTransform: 'uppercase' }}
                            >
                                <MenuItem value='' key=''>Ninguno</MenuItem>
                                {listaFormasPagos.map(item => (
                                    <MenuItem value={item.id} key={item.id} style={{ textTransform: 'uppercase' }}>{item.nombre}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid> */}

                    <Grid item xs={12} sm={6}>
                        <div className='d-flex justify-content-center align-items-center'>
                            <Selects
                                label='Forma de pago'
                                name='id_forma_pago'
                                value={form.id_forma_pago}
                                data={listaFormasPagos}
                                onChange={onInputChange}
                                style={{ textTransform: 'uppercase' }}
                            />
                            <Tooltip title="Agregar/modificar formas de pago">
                                <i
                                    className="bi bi-pencil ms-2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setOpenDialogFormaPago(true)}
                                ></i>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            style={{ width: '100%' }}
                            id="outlined-multiline-static"
                            label="Observaciones"
                            multiline
                            rows={4}
                            name="observaciones_compras"
                            value={form.observaciones_compras || ''}
                            onChange={onInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Nombre tipo gasto"
                            name="nombre_tipo_compra"
                            id="outlined-size-small"
                            value={form.nombre_tipo_compra || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese nombre tipo gasto'
                            onChange={onInputChange}
                        />
                    </Grid>

                    <Grid item xs={12} className='mt-2'>
                        <div>
                            <Buttons
                                label='Guardar cambios'
                                type='submit'
                            />
                        </div>
                    </Grid>

                </Grid>

            </form>

            {openDialogFormaPago &&
                <DialogFormaPago
                    open={openDialogFormaPago}
                    setOpen={setOpenDialogFormaPago}
                    origen="compras"
                />
            }

        </div>
    )
}